angular.module('FmsApp').controller("ViewEmergencyContactController", ["$scope", "EmergencyContactFactory", "farm_slug",
    function ($scope, EmergencyContactFactory, farm_slug) {
        $scope.emergency_contact = EmergencyContactFactory.get({farm_slug: farm_slug},
            function (result) {
                $scope.emergency_contact = result;
            });
    }]);